import React from 'react';
import { Grid, Select, Button, Icon } from 'semantic-ui-react';
import { FilePreviewLink } from './FilePreviewLink';
import { FacturaBloqueada, facturaBloqueada } from './FacturaBloqueada';
import { getDisplayFileName } from '../../utils/fileUtils';

export const DocumentManager = React.memo(({
  documentos,
  tiposDocs,
  tipoDocumento,
  disabled = false,
  onTipoDocChange,
  onFileChange,
  onDocDelete,
  id,
  onUploadClick,
  uploadDisabled = false,
  uploadLoading = false,
}) => {
  return (
    <>
      <h5 style={{ marginBottom: "5px" }}>Documentos</h5>
      {!disabled && (
        <Grid.Row>
          <Grid.Column computer={16} mobile={16} tablet={16}>
            <Select
              name="tipo_documento"
              placeholder="Seleccionar Tipo"
              options={tiposDocs.map((x) => {
                return { key: x.id, value: x.id, text: x.nombre };
              })}
              onChange={onTipoDocChange}
              value={tipoDocumento}
            />
            <input
              className="input"
              accept="'image/jpg'"
              type="file"
              style={{ marginTop: "5px" }}
              onChange={(e) => {
                if (onFileChange) {
                  const file = e.target.files && e.target.files[0];
                  onFileChange(file || null);
                }
              }}
              disabled={disabled || !tipoDocumento}
            />
            <Button
              style={{ marginTop: "5px", marginLeft: "5px" }}
              size="small"
              type="button"
              primary
              onClick={onUploadClick}
              loading={uploadLoading}
              disabled={disabled || uploadDisabled}
            >
              Cargar
            </Button>
          </Grid.Column>
        </Grid.Row>
      )}
      <Grid.Row>
        <Grid.Column computer={16} mobile={16} tablet={16}>
          {documentos.length > 0 ? (
            documentos.map((doc) => {
              // Factura de la clinica cargada por otro usuario: no se abre ni se borra
              if (facturaBloqueada(doc)) {
                return (
                  <div key={doc.id}>
                    <FacturaBloqueada cargadoPor={doc.created_by_nombre}>
                      {doc.tipo_documento_nombre}
                    </FacturaBloqueada>
                  </div>
                );
              }
              return (
                <div key={doc.id}>
                  <FilePreviewLink
                    filePath={doc.url_archivo}
                    style={
                      doc.deleted ? { textDecoration: "line-through" } : {}
                    }
                  >
                    {doc.tipo_documento_nombre}:{" "}
                    {doc.url_archivo ? getDisplayFileName(doc.url_archivo) : ''}
                  </FilePreviewLink>
                  {!disabled && (
                    <Button
                      style={{ margin: "5px 5px" }}
                      size="mini"
                      type="button"
                      icon
                      negative
                      basic
                      onClick={() => onDocDelete(doc.id)}
                    >
                      <Icon name="close" />
                    </Button>
                  )}
                </div>
              );
            })
          ) : (
            <p>No hay documentos adjuntos</p>
          )}
        </Grid.Column>
      </Grid.Row>
    </>
  );
});

